var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { height: "100%", "content-class": "contest-entered-dialog" },
      model: {
        value: _vm.showDialog,
        callback: function($$v) {
          _vm.showDialog = $$v
        },
        expression: "showDialog"
      }
    },
    [
      _c("h3", [_vm._v(_vm._s(_vm.$t("Contests.Entered.Dialog.Heading")))]),
      _vm._v(" "),
      _c("div", { staticClass: "contest-alias-wrapper" }, [
        _c("span", { staticClass: "contest-info-dialog--usericon" }),
        _c("h1", { staticClass: "contest-alias" }, [
          _vm._v(_vm._s(_vm.contestAlias))
        ])
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "contest-name" }, [
        _vm._v(_vm._s(_vm.contestName))
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("Contests.Entered.Dialog.Start")))]),
      _vm._v(" "),
      _c("p", { staticClass: "contest-start-time" }, [
        _vm._v(_vm._s(_vm.contestStartTime))
      ]),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "primary-btn btn--ok",
          on: {
            click: function($event) {
              _vm.showDialog = false
            }
          }
        },
        [_vm._v("OK")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bfc7a1ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfc7a1ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/contests/contestEnteredDialog.vue
// module id = null
// module chunks = 